import moment, { Moment } from 'moment-timezone';
import { LegFiJwtService } from '../../services/auth/legfi-jwt.service';

/** Opt out (or in) to lob mail */
export class LobMailOptOut
{
    id: number;
    email: string;
    ip: string;
    isEnrolled: boolean;
    organizationId: number;
    userId: number;
    createdAt: Moment;

    constructor(optOut: any) {
        this.id = optOut.id;
        this.organizationId = optOut.organizationId;
        this.userId = optOut.userId;
        this.ip = optOut.ip;
        this.email = optOut.email;
        this.isEnrolled = optOut.isEnrolled;

        const timezone = LegFiJwtService.getTimezone();
        if (optOut.createdAt) {
            this.createdAt = moment.utc(optOut.createdAt, 'YYYY-MM-DD hh:mm:ss').tz(timezone);
        }
    }
}
